import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const choiceChipDefaultVariants = {
  "type": "rounded",
  "selected": false,
  "redDot": false
}
const choiceChipCompoundVariants = [
  {
    "selected": false,
    "redDot": true,
    "css": {
      "redDot": {
        "display": "inherit"
      }
    }
  }
]

const choiceChipSlotNames = [
  [
    "container",
    "choice-chip__container"
  ],
  [
    "icon",
    "choice-chip__icon"
  ],
  [
    "label",
    "choice-chip__label"
  ],
  [
    "root",
    "choice-chip__root"
  ],
  [
    "badge",
    "choice-chip__badge"
  ],
  [
    "redDot",
    "choice-chip__redDot"
  ]
]
const choiceChipSlotFns = /* @__PURE__ */ choiceChipSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, choiceChipDefaultVariants, getSlotCompoundVariant(choiceChipCompoundVariants, slotName))])

const choiceChipFn = memo((props = {}) => {
  return Object.fromEntries(choiceChipSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const choiceChipVariantKeys = [
  "type",
  "selected",
  "redDot"
]
const getVariantProps = (variants) => ({ ...choiceChipDefaultVariants, ...compact(variants) })

export const choiceChip = /* @__PURE__ */ Object.assign(choiceChipFn, {
  __recipe__: false,
  __name__: 'choiceChip',
  raw: (props) => props,
  variantKeys: choiceChipVariantKeys,
  variantMap: {
  "type": [
    "rounded",
    "square"
  ],
  "selected": [
    "true",
    "false"
  ],
  "redDot": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, choiceChipVariantKeys)
  },
  getVariantProps
})